import bbPublicBookingModule from 'bookingbug-angular/src/public-booking/main.module';
import 'bookingbug-angular/src/public-booking/globs_to_remove';//TODO remove once globs removed on sdk

import 'angular-bootstrap-lightbox';
import 'ng-showdown';

import './sdk-templates/core/-inputs/question/question_date.html';
import './sdk-templates/member/_templates/member_booking_delete_modal.html';
import './sdk-templates/member/_templates/steps-main/main_account.html';
import './sdk-templates/member/_templates/steps/account.html';
import './sdk-templates/member/_templates/steps/login.html';
import './sdk-templates/member/member-booking/member_booking.html';
import './sdk-templates/member/member-form/member_form.html';
import './sdk-templates/member/member-form/member_schema_form.html';
import './sdk-templates/member/member-login/member_login_form.html';
import './sdk-templates/member/member-purchases/member_purchases.html';
import './sdk-templates/public-booking/_templates/steps-main/main_event.html';
import './sdk-templates/public-booking/_templates/steps/basket_summary.html';
import './sdk-templates/public-booking/_templates/steps/checkout_event.html';
import './sdk-templates/public-booking/_templates/steps/client.html';
import './sdk-templates/public-booking/_templates/steps/confirmation.html';
import './sdk-templates/public-booking/_templates/steps/event_list.html';
import './sdk-templates/public-booking/_templates/steps/event.html';
import './sdk-templates/public-booking/client-details/client_details.html';
import './sdk-templates/public-booking/items-details/item_details.html';
import './sdk-templates/public-booking/month-picker/month_picker.html';
import '../../tmp/config.constants';

//templates
import './templates/member/steps/change_password.html';
import './templates/public-booking/footers/family_hubs.html';
import './templates/public-booking/footers/heritage.html';
import './templates/public-booking/headers/family_hubs.html';
import './templates/public-booking/headers/heritage.html';
import './templates/public-booking/member_bar.html';
import './templates/public-booking/steps/event_details.html';
import './templates/public-booking/steps/login.html';
import './templates/public-booking/steps/payment.html';
import './templates/steps-main/main_all_events.html';
import './templates/steps-main/main_family_hub_events.html';
import './templates/steps-main/main_heritage_events.html';
import './templates/steps-main/main_library_events.html';
import './templates/steps-main/main_payment_confirmation.html';

import './sdk-templates/public-booking/purchase/_models/purchase_total_model.service'

//javascripts
import './javascripts/address-lookup/address_lookup.module.js';
import './javascripts/alert-message/alert_message.module.js';
import './javascripts/all-events/all_events.module.js';
import './javascripts/are-you-sure/are_you_sure.module.js';
import './javascripts/banner-filter/banner_filter.module.js';
import './javascripts/basket/basket.module.js';
import './javascripts/bl-booking-export/bl_export.module.js';
import './javascripts/bl-confirmation/bl-confirmation.module.js';
import './javascripts/booking-details-list/booking_details_list.module.js';
import './javascripts/category-filter-list/category_filter_list.module.js';
import './javascripts/change-password/change_password.module.js';
import './javascripts/checkout/wb_checkout.module.js';
import './javascripts/clear-tickets/clear_tickets.module.js';
import './javascripts/clear-url-params/clear-url-params.module.js';
import './javascripts/client-details/bb_client_deails.module.js';
import './javascripts/client-number/client-number.module.js';
import './javascripts/client-summary/client_summary.module.js';
import './javascripts/copy-permalink/copy_permalink.module.js';
import './javascripts/custom-questions/custom_questions.module.js';
import './javascripts/edit-member-details/edit_member_details.module.js';
import './javascripts/event-back-button/event_back_button.module.js';
import './javascripts/event-banner/event_banner.module.js';
import './javascripts/event-date-picker/event_date_list.module.js';
import './javascripts/filter-tags/filter_tags.module.js';
import './javascripts/filter/ticket_quantity.module.js';
import './javascripts/image-gallery/image_gallery.module.js';
import './javascripts/is-empty-filter/is_empty.module.js';
import './javascripts/logout-contact/logout_contact.module.js';
import './javascripts/member-login/member_login.module.js';
import './javascripts/no-click-focus/no_click_focus.module.js';
import './javascripts/payment-redirect/payment_redirect.module.js';
import './javascripts/question-answers-list/question_answers_list.module.js';
import './javascripts/question-filter-list/question_filter_list.module.js';
import './javascripts/readable-datetime/readable_datetime.module.js';
import './javascripts/skip-step-function/skip_step.module.js';
import './javascripts/skip-to-content/skip_to_content.module.js';
import './javascripts/terms/terms.module.js';
import './javascripts/ticket-numbering-filter/ticket_numbering.module.js';
import './javascripts/youtube-video/youtube_video.module.js';
import './javascripts/address-lookup/address_lookup.service.js';
import './javascripts/address-lookup/address_lookup.component.js';
import './javascripts/alert-message/alert_message.component.js';
import './javascripts/basket/mini-basket/mini_basket.component.js';
import './javascripts/basket/summary/basket_summary.component.js';
import './javascripts/basket/ticket_count/basket.component.js';
import './javascripts/booking-details-list/booking_details_list.component.js';
import './javascripts/category-filter-list/category_filter_list.component.js';
import './javascripts/change-password/change_password.component.js';
import './javascripts/client-number/client-number.component.js';
import './javascripts/client-summary/client_summary.component.js';
import './javascripts/edit-member-details/edit_member_address.component.js';
import './javascripts/edit-member-details/edit_member_details.component.js';
import './javascripts/event-banner/event_banner.component.js';
import './javascripts/event-date-picker/event_date_list.component.js';
import './javascripts/image-gallery/image_gallery.component.js';
import './javascripts/question-answers-list/question_answers_list.component.js';
import './javascripts/question-filter-list/question_filter_list.component.js';
import './javascripts/readable-datetime/readable_datetime.component.js';
import './javascripts/skip-to-content/skip_to_content.component.js';
import './javascripts/terms/terms.component.js';
import './javascripts/youtube-video/youtube_video.component.js';
import './javascripts/all-events/all_events.directive.js';
import './javascripts/are-you-sure/are_you_sure.directive.js';
import './javascripts/banner-filter/banner_filter.directive.js';
import './javascripts/basket/empty-basket/empty_basket.directive.js';
import './javascripts/basket/skip-ticket-summary/skip_ticket_summary.directive.js';
import './javascripts/bl-booking-export/bl_booking_export.directive.js';
import './javascripts/bl-confirmation/bl-confirmation.directive.js';
import './javascripts/checkout/wb_checkout.directive.js';
import './javascripts/clear-tickets/clear_tickets.directive.js';
import './javascripts/clear-url-params/clear-url-params.directive.js';
import './javascripts/client-details/bb_client_details.directive.js';
import './javascripts/copy-permalink/copy_permalink.directive.js';
import './javascripts/event-back-button/event_back_button.directive.js';
import './javascripts/filter-tags/filter_tags.directive.js';
import './javascripts/logout-contact/logout_contact.directive.js';
import './javascripts/member-login/member_login.directive.js';
import './javascripts/no-click-focus/no_click_focus.directive.js';
import './javascripts/payment-redirect/payment_redirect.directive.js';
import './javascripts/skip-step-function/skip_step.directive.js';
import './javascripts/custom-questions/custom_questions.filter.js';
import './javascripts/custom-questions/use_my_details_address.filter.js';
import './javascripts/filter/booking_question_name.filter.js';
import './javascripts/filter/can_use_client_details.filter.js';
import './javascripts/filter/ticket_quantity.filter.js';
import './javascripts/filter/use_my_details.filter.js';
import './javascripts/is-empty-filter/is_empty.filter.js';
import './javascripts/ticket-numbering-filter/ticket_numbering.filter.js';
import './javascripts/all-events/all_events.controller.js';
import './javascripts/basket/clear-basket/clear_basket.controller.js';
import './javascripts/checkout/wb_checkout.controller.js';
import './javascripts/client-details/bb_client_details.controller.js';

// fonts
import './fonts/bb-icons.eot';
import './fonts/bb-icons.ttf';
import './fonts/bb-icons.woff';
import 'file-loader?name=fonts/[name].[ext]!./fonts/bb-icons.svg';

//images
import './images/west_berkshire_footer_logo.jpg';

// styles
import './main.scss';

import 'file-loader?name=angular-i18n/[name].[ext]!bookingbug-angular/node_modules/angular-i18n/angular-locale_en.js';
import 'file-loader?name=angular-i18n/[name].[ext]!bookingbug-angular/node_modules/angular-i18n/angular-locale_fr.js';

import config from './main.config';
import run from './main.run';
import categoryFilterListModule from './javascripts/category-filter-list/category_filter_list.module';
import questionFilterListModule from './javascripts/question-filter-list/question_filter_list.module';
import filterTagsModule from './javascripts/filter-tags/filter_tags.module';
import copyPermaLink from './javascripts/copy-permalink/copy_permalink.module';
import quantityTotalModule from './javascripts/filter/ticket_quantity.module';
import wbBasketModule from './javascripts/basket/basket.module';
import wbClientSummaryModule from './javascripts/client-summary/client_summary.module';
import wbPaymentRedirectModule from './javascripts/payment-redirect/payment_redirect.module';
import wbCustomQuestions from './javascripts/custom-questions/custom_questions.module';
import wbAddressLookupModule from './javascripts/address-lookup/address_lookup.module';
import wbAreYouSureModule from './javascripts/are-you-sure/are_you_sure.module';
import wbBookingDetailsListModule from './javascripts/booking-details-list/booking_details_list.module';
import wbQuestionAnswersListModule from './javascripts/question-answers-list/question_answers_list.module';
import wbReadableDatetime from './javascripts/readable-datetime/readable_datetime.module';
import wbChangePasswordModule from './javascripts/change-password/change_password.module';
import fdAllEventsModule from './javascripts/all-events/all_events.module';
import wbEventBannerModule from './javascripts/event-banner/event_banner.module';
import wbIsEmptyFilterModule from './javascripts/is-empty-filter/is_empty.module';
import wbImageGalleryModule from './javascripts/image-gallery/image_gallery.module';
import wbYoutubeVideoModule from './javascripts/youtube-video/youtube_video.module';
import wbTicketNumberingModule from './javascripts/ticket-numbering-filter/ticket_numbering.module';
import wbClearBasketModule from './javascripts/clear-tickets/clear_tickets.module';
import wbTermsModule from './javascripts/terms/terms.module';
import wbEditMemberDetailsModule from './javascripts/edit-member-details/edit_member_details.module';
import wbSkipToContentModule from './javascripts/skip-to-content/skip_to_content.module';
import wbAlertMessageModule from './javascripts/alert-message/alert_message.module';
import wbLogoutContact from './javascripts/logout-contact/logout_contact.module';
import wbNoClickFocusModule from './javascripts/no-click-focus/no_click_focus.module';
import wbCheckoutModule from './javascripts/checkout/wb_checkout.module';
import wbClearUrlParams from './javascripts/clear-url-params/clear-url-params.module';
import wbbannerFilter from './javascripts/banner-filter/banner_filter.module';
import wbClientNumber from './javascripts/client-number/client-number.module';
import blMemberLoginModule from './javascripts/member-login/member_login.module';
import blClientDetails from './javascripts/client-details/bb_client_deails.module';
import blConfirmationModule from './javascripts/bl-confirmation/bl-confirmation.module';
import blEventDateList from './javascripts/event-date-picker/event_date_list.module';
import blSkipStep from './javascripts/skip-step-function/skip_step.module';
import blBackButton from './javascripts/event-back-button/event_back_button.module';
import blExportButtons from './javascripts/bl-booking-export/bl_export.module';

export default angular
    .module('westBerkshireEvents', [
        'bootstrapLightbox',
        'ng-showdown',
        'ngSanitize',
        bbPublicBookingModule,
        categoryFilterListModule,
        questionFilterListModule,
        filterTagsModule,
        copyPermaLink,
        quantityTotalModule,
        wbBasketModule,
        wbClientSummaryModule,
        wbPaymentRedirectModule,
        wbCustomQuestions,
        wbAddressLookupModule,
        wbAreYouSureModule,
        wbBookingDetailsListModule,
        wbQuestionAnswersListModule,
        wbReadableDatetime,
        wbChangePasswordModule,
        fdAllEventsModule,
        wbEventBannerModule,
        wbIsEmptyFilterModule,
        wbImageGalleryModule,
        wbYoutubeVideoModule,
        wbTicketNumberingModule,
        wbClearBasketModule,
        wbTermsModule,
        wbEditMemberDetailsModule,
        wbSkipToContentModule,
        wbAlertMessageModule,
        wbLogoutContact,
        wbNoClickFocusModule,
        wbCheckoutModule,
        wbClearUrlParams,
        wbbannerFilter,
        wbClientNumber,
        blMemberLoginModule,
        blClientDetails,
        blConfirmationModule,
        blEventDateList,
        blSkipStep,
        blBackButton,
        blExportButtons
    ])
    .config(config)
    .run(run)
    .name;


// WEBPACK FOOTER //
// src/public/main.module.js